import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'one_year_filing_deadline'
const storeType = 'oneYearFilingDeadlines'

export const PEOneYearFilingDeadlinesCardActions = {
  initPeOneYearFilingDeadlinesCard: ({ commit }, index) => {
    commit('setPeOneYearFilingDeadlinesCardLock', { index, lock: true })
  },
  peFetchOneYearFilingDeadlinesCards: async ({ commit, getters, dispatch }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peOneYearFilingDeadlinesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            arrival_date: section.arrival_date,
            arrival_date_unknown: section.arrival_date_unknown,
            filed_more_than_one_year: section.filed_more_than_one_year,
            does_an_exception_apply: section.does_an_exception_apply,
            exception_type: section.exception_type,
            exception_basis: section.exception_basis,
            exception_end_date: section.exception_end_date,
            exception_end_date_unknown: section.exception_end_date_unknown,
            narrative: section.narrative,
            party_id: section.party_id,
            calculated_reasonable_time: section.calculated_reasonable_time,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeOneYearFilingDeadlinesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peOneYearFilingDeadlinesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeOneYearFilingDeadlinesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peOneYearFilingDeadlinesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            arrival_date: section.arrival_date,
            arrival_date_unknown: section.arrival_date_unknown,
            filed_more_than_one_year: section.filed_more_than_one_year,
            does_an_exception_apply: section.does_an_exception_apply,
            exception_type: section.exception_type,
            exception_basis: section.exception_basis,
            exception_end_date: section.exception_end_date,
            exception_end_date_unknown: section.exception_end_date_unknown,
            narrative: section.narrative,
            party_id: section.party_id,
            calculated_reasonable_time: section.calculated_reasonable_time,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeOneYearFilingDeadlinesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peOneYearFilingDeadlinesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeOneYearFilingDeadlinesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peOneYearFilingDeadlinesCardAddSection: ({ commit }) => {
    commit('setPeOneYearFilingDeadlinesCardLock', { index: 'new', lock: false })
    commit('addPeOneYearFilingDeadlinesCardSection', {
      id: null,
      arrival_date: null,
      arrival_date_unknown: false,
      filed_more_than_one_year: false,
      does_an_exception_apply: false,
      exception_type: '',
      exception_basis: '',
      exception_end_date: null,
      exception_end_date_unknown: false,
      narrative: '',
      party_id: null,
      calculated_reasonable_time: null,
    })
  },
  peOneYearFilingDeadlinesCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PEOneYearFilingDeadlinesCardMutations = {
  setPeOneYearFilingDeadlinesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.OneYearFilingDeadlinesCard) {
      Vue.set(state.partyEdit.partySections, 'OneYearFilingDeadlinesCard', {})
    }
    Vue.set(state.partyEdit.partySections.OneYearFilingDeadlinesCard, index, lock)
  },
  addPeOneYearFilingDeadlinesCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peOneYearFilingDeadlinesCardCreateUndo: state => state.partyEdit.asylumAssystant[storeType].pop(),
}

export const PEOneYearFilingDeadlinesCardGetters = {
  peOneYearFilingDeadlinesCardLock: state => index => state.partyEdit.partySections.OneYearFilingDeadlinesCard[index],
  peOneYearFilingDeadlinesCardHasNewSection: state => !!state.
    partyEdit.
    asylumAssystant[storeType]?.
    find(aka => aka.id === null),
}
